"use client";

import Link from "next/link";
import { Minus, Plus } from "lucide-react";
import type { CartProductSnapshot } from "@/lib/types";
import { maxQuantity } from "@/lib/cart";
import { number } from "@/lib/config";
import { useCart } from "./cart-provider";

export function QuickAdd({ product, tabIndex }: { product: CartProductSnapshot; tabIndex?: number }) {
  const { add, ready, lines, update } = useCart();
  const choices = product.variants.filter((variant) => maxQuantity(variant) > 0);
  const variant = choices.length === 1 ? choices[0] : null;
  if (product.demo || product.purchasable === false || choices.length === 0) return null;
  if (!variant) return <Link tabIndex={tabIndex} className="product-quick-add" href={`/products/${product.slug}`} aria-label={`انتخاب مدل ${product.name}`} title="انتخاب رنگ یا مدل"><Plus size={18} aria-hidden="true" /></Link>;
  const quantity = lines.find((line) => line.variantId === variant.id)?.quantity ?? 0;
  return quantity > 0 ? (
    <div className="product-quick-stepper" role="group" aria-label={`تعداد ${product.name}`}>
      <button type="button" tabIndex={tabIndex} disabled={!ready || quantity >= maxQuantity(variant)} aria-label={`افزایش تعداد ${product.name}`} onClick={() => update(variant.id, quantity + 1)}><Plus size={15} aria-hidden="true" /></button>
      <span key={quantity} className="product-quick-count" aria-live="polite">{number(quantity)}</span>
      <button type="button" tabIndex={tabIndex} disabled={!ready} aria-label={`کاهش تعداد ${product.name}`} onClick={() => update(variant.id, quantity - 1)}><Minus size={15} aria-hidden="true" /></button>
    </div>
  ) : (
    <button type="button" tabIndex={tabIndex} className="product-quick-add" disabled={!ready} aria-label={`افزودن ${product.name} به سبد خرید`} title="افزودن به سبد خرید" onClick={() => add(variant.id, 1, false, product)}><Plus size={18} aria-hidden="true" /></button>
  );
}
